import { faSquareDashedCirclePlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardActionArea, CardContent } from '@mui/material';
import { FunctionComponent } from 'react';

type AddMetricButtonProps = {
  onClick: () => void;
};

const AddMetricButton: FunctionComponent<AddMetricButtonProps> = ({ onClick }) => {
  return (
    <Card className="min-w-36 rounded-lg border-dashed border-gray-300 bg-gray-100 dark:bg-gray-900 dark:border-gray-700">
      <CardActionArea className="flex h-full items-center justify-center pl-1" onClick={onClick}>
        <CardContent>
          <FontAwesomeIcon size="2xl" icon={faSquareDashedCirclePlus} className={'disabled-opacity-reduce'} />
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default AddMetricButton;
